module.exports = __webpack_public_path__ + "static/media/Reset.12cf1e5d.svg";